<template>
  <!-- CSS命名参考BEM规范 -->
  <div class="navLeft"
       :class='{"collapsed": isCollapsed}'
       @mouseleave="onCollapse(true), onShowNavAllPanel(false)"
       @mouseover="onCollapse(false)">
    <div class="navLeft__list">
      <div class="navLeft__item navLeft__service" @mouseover="onShowNavAllPanel(true)">
        <a  :style="{width: isCollapsed ? '100%' : '195px'}">
          <i class="icon icon-menu"></i>
          <div class="navLeft__itemName"
               v-if="!isCollapsed"
               :title="产品与服务">产品与服务</div>
        </a>
        <div v-if="!isCollapsed"
             class="handle handle__arrow-right"></div>
      </div>
      <draggable class="list-group"
                 v-model="checkList"
                 @change="onChange()"
                 @start="dragTo(true)"
                 @end="dragTo(false)"
                 handle=".handle__move"
                 v-bind="dragOptions">
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div class="navLeft__item navLeft__product list-group-item"
               v-for="(o,index) in navLeftMenu"
               :key="index"
               :class="[canHandleNumber === index ? 'product__hover' : '']"
               @mouseover="showHandle(index, o.href)"
               @mouseleave="canHandleNumber = null"
               @click="onShowNavAllPanel(false)">
            <a v-if="o"
               :href="o.href.indexOf('sku')>-1 ? o.href+'&name='+o.name : o.href"
               :style="{width: isCollapsed ? '100%' : '195px'}">
              <i class="icon" :class="o.icon"></i>
              <div class="navLeft__itemName"
                   v-if="!isCollapsed"
                   v-text="o.name"
                   :title="o.name"></div>
            </a>
            <div v-if="!isCollapsed && canHandleNumber === index"
                 @click.stop="onRemoveLeftMenu(o)"
                 class="handle handle__delete"></div>
            <div v-if="!isCollapsed && canHandleNumber === index"
                 class="handle handle__move"></div>
          </div>
        </transition-group>
      </draggable>
    </div>
    <div class="navLeft__setting">
       <!--删除菜单配置入口 -->
      <!--<div class="navLeft__settingItem" @click="onSettingLeftMenu">-->
        <!--<i-->
          <!--class="icon icon-cog"-->
          <!--style="font-size: 16px; vertical-align: middle; margin-right: 10px; color: #aab1bb;"-->
        <!--&gt;</i>-->
        <!--快捷菜单配置-->
      <!--</div>-->
      <!--<div class="navLeft__collapsedItem" @click="onCollapse()">-->
        <!--<div class="navLeft__collapsedIcon"-->
             <!--:class="[isCollapsed ? 'expansion' : 'closing']">-->
          <!--<i-->
            <!--class="icon icon-indent_right"-->
            <!--style="font-size: 14px; vertical-align: middle; color: #aab1bb;"-->
          <!--&gt;</i>-->
        <!--</div>-->
        <!--<div class="navLeft__settingTip" v-if="!isCollapsed">收起菜单</div>-->
        <!--<div class="navLeft__settingTip" v-if="isCollapsed">展开菜单</div>-->
      <!--</div>-->
    </div>

    <nav-setting-panel v-if="isShowNavSettingPanel" @close="onCloseDialog"></nav-setting-panel>
    <transition name="navAllPanelFade" >
      <nav-all-panel v-if="isShowNavAllPanel"
                     @mouseleave.native ="onShowNavAllPanel(false)"
                     @hiddenNavAllPanel="onShowNavAllPanel(false), onCollapse(true)"
                     @keepStatus="onCollapse(isCollapsed)"
                     @closePanel="onShowNavAllPanel(false)"
                     :marginLeft = marginLeft
                     :deleteHref = deleteHref></nav-all-panel>
    </transition>
  </div>
</template>

<script>
import NavSettingPanel from './NavSettingPanel.vue';
import globalEventName from '../../globalEventName';
import NavAllPanel from './NavAllPanel.vue';
import draggable from "vuedraggable";
import mutationTypes from '../../store/mutation-types';
import actionTypes from '../../store/action-types';

export default {
  components: {
    'nav-setting-panel': NavSettingPanel,
    'nav-all-panel': NavAllPanel,
     draggable
  },

  data() {
    return {
      isCollapsed: true,
      isDraggable: false,
      isShowNavSettingPanel: false,
      isShowNavAllPanel: false,
      marginLeft: 55,
      checkList: [],
      canHandleNumber: null,
      deleteHref: '',
      drag: false,
      changeHref: ''
    }
  },

  computed: {
    navLeftMenu() {
      this.init();
      return this.$store.state.navLeftMenu;
    },
    navTopMenu: function () {
      return this.$store.state.navTopMenu;
    },
    dragOptions() {
        return {
            animation: 200,
            group: "description",
            disabled: false,
            ghostClass: "ghost"
        };
    }
  },

  methods: {
    init() {
        let sideBarMenu = JSON.parse(sessionStorage.getItem("navLeftMenu")) || [];
        // console.log(sideBarMenu)
        this.checkList = sideBarMenu.map(item => item.href);
    },
    onCollapse(status) {
      if (this.drag && status) return ;
      if (typeof status === 'boolean') {
        this.isCollapsed = status;
      } else {
        this.isCollapsed = !this.isCollapsed;
      }
      this.$emit('showAllLeft', this.isCollapsed);
      let selector = document.querySelector('#MONO_CONTENT');
      let selectorClass = selector.getAttribute("class");
      if(this.isCollapsed) {
          this.marginLeft = 55;
          // selectorClass = selectorClass.indexOf('collapsed') < 0 ? selectorClass.concat(" collapsed") : selectorClass;
      } else {
          this.marginLeft = 240;
          // selectorClass = selectorClass.replace("collapsed","");
      }
      selector.setAttribute("class",selectorClass );
      this.$store.state.globalEventDistributor.emit(globalEventName.UPDATE_UNI_NAV_COLLAPSED, {
        name: 'isNavCollapsed',
        value: this.isCollapsed
      });
    },

    dragTo(val) {
        this.drag = val;
        if(!val){
            this.canHandleNumber = this.checkList.indexOf(this.changeHref)
        } else {
            this.canHandleNumber = null
        }
    },

    onSettingLeftMenu() {
      this.isShowNavSettingPanel = true;
    },

    onChange(){
        let list = [];
        for(let i = 0; i < this.checkList.length; i ++){
            for(let j = 0; j < this.$store.state.navLeftMenu.length; j ++) {
                if(this.$store.state.navLeftMenu[j].href === this.checkList[i]){
                    list.push(this.$store.state.navLeftMenu[j])
                }
            }
        }
        this.$store.state.navLeftMenu = list;
        this.navLeftMenu = this.list;
        //this.$store.commit(mutationTypes.SET_NAV_LEFT_MENU, list);
        this.$store.dispatch(actionTypes.UPDATE_NAV_LEFT_MEUN, list);
        },

    showHandle(index, href) {
        if(!this.drag) {
            this.canHandleNumber = index;
            this.changeHref = href;
        }
    },

    onRemoveLeftMenu(item) {
        this.deleteHref = item.href;
        this.checkList = this.checkList.filter(href => {
            return href !== item.href;
        });
        this.$store.state.navLeftMenu = this.$store.state.navLeftMenu.filter(navItem => {
            return navItem.href !== item.href;
        });
        let navLeftMenu = this.navLeftMenu;
        this.$store.dispatch(actionTypes.UPDATE_NAV_LEFT_MEUN, navLeftMenu);
        // this.$store.commit(mutationTypes.SET_NAV_LEFT_MENU, navLeftMenu);
    },

    onCloseDialog() {
      this.isShowNavSettingPanel = false;
    },

    onShowNavAllPanel(status) {
        this.isShowNavAllPanel = status;
    },
  },
   created() {
      this.init()
   }
};
</script>

<style scoped>
.navLeft {
  position: fixed;
  top: 50px;
  left: 0;
  width: 240px;
  height: calc(100% - 50px);
  z-index: 2001;
  background-color: #1e222b;
  transition: width 0.3s ease-in-out 0s;
  padding-bottom: 50px;
  /*overflow-y: auto;*/
}

.navLeft__list {
/*padding-top: 15px;*/
  background-color: #1e222b;
  height: calc(100%);
  overflow-y: auto;
  overflow-x: hidden;
  /*z-index: 100;*/
}

.navLeft__item {
  display: block;
  /*cursor: pointer;*/
  position: relative;
  width: 100%;
  line-height: 50px;
  height: 50px;
  font-size: 12px;
  color: rgb(163, 163, 163);
  text-align: left;
}

.navLeft__service {
  cursor: pointer;
  border-bottom: 1px solid #454951
}

.navLeft__itemName {
  color: #eaeaea;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100px;
  vertical-align: middle;
}

.navLeft.collapsed .navLeft__item {
  text-align: center;
}

.navLeft__item i {
  font-size: 18px;
  vertical-align: middle;
  margin: 0px 20px 0 18px;
  color: #E2E2E2
}

.handle {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
}

.handle__arrow-right {
  right: 12px;
  background: url("../../assets/images/arrow-right.svg");
}

.handle__delete {
  /*cursor: pointer;*/
  right: 34px;
  background: url("../../assets/images/close-delete.svg");
}

.handle__move {
  cursor: move;
  right: 12px;
  background: url("../../assets/images/move.svg");
}

.navLeft__item a {
  font-size: 12px;
  color: #eaeaea;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*width: 195px;*/
  display: inline-block;
}

.navLeft__item a:hover {
  text-decoration: none;
}

.navLeft__setting {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto auto 0px auto;
  height: 50px;
  background-color: #1e222b;
}

.navLeft__settingItem {
  cursor: pointer;
  float: left;
  width: 145px;
  font-size: 12px;
  margin: 0;
  background-position-y: center;
  background-position-x: 10px;
  color: #eaeaea;
  background-repeat: no-repeat;
  height: 100%;
  line-height: 50px;
  padding: 0 0 0 10px;
  transition: all 0.3s ease-in-out 0s;
  overflow: hidden;
}

.navLeft__collapsedItem {
  float: right;
  width: 35px;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  color: rgb(163, 163, 163);
  line-height: 50px;
  text-align: center;
  margin: 0;
  cursor: pointer;
}

.navLeft__collapsedItem:hover {
  /*color: #26749D;*/
}

.navLeft__collapsedItem:hover .navLeft__settingTip {
  display: block;
}

.navLeft__settingTip {
  display: none;
  position: absolute;
  left: 250px;
  font-size: 12px;
  white-space: nowrap;
  padding: 0px 15px;
  background-color: rgb(37, 37, 37);
  z-index: 1;
  line-height: 30px;
  top: 15px;
  color: rgb(163, 163, 163);
  transition: all 0.3s ease-in-out 0s;
}

.navLeft__settingTip:after {
  content: " ";
  width: 10px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto auto auto -2px;
  border-top: 10px solid rgb(37, 37, 37);
  border-right: 10px solid rgb(37, 37, 37);
  transform: rotate(225deg);
}

/*折叠样式*/
.navLeft.collapsed {
  width: 55px;
}

.navLeft.collapsed .navLeft__item {
  text-align: center;
}

.navLeft.collapsed .navLeft__collapsedItem {
  width: 55px;
}

.navLeft.collapsed .navLeft__itemName {
  display: none;
}

.navLeft__collapsedItem .navLeft__collapsedIcon {
  width: 100%;
  height: 16px;
  margin-top: 25px;
}

.navLeft__collapsedItem .navLeft__collapsedIcon.expansion {
  background: url("../../assets/images/expansion01.svg") no-repeat center;
}

.navLeft__collapsedItem .navLeft__collapsedIcon.closing {
  background: url("../../assets/images/closing01.svg") no-repeat center;
}

.navLeft.collapsed .navLeft__settingItem {
  width: 0;
  border: 0;
  padding: 0;
}

.navLeft.collapsed .navLeft__item:hover {
  background-color: #2587f6;
}

.navLeft.collapsed .navLeft__item:hover i {
  color: #fff;
}

.navLeft.collapsed .navLeft__service:hover {
  background-color: #1e222b;
}

.navLeft.collapsed .navLeft__service:hover i {
  color: #2587f6;
}

.navLeft.collapsed .navLeft__item:hover .navLeft__itemName {
  display: block;
  position: absolute;
  left: 65px;
  white-space: nowrap;
  padding: 0px 15px;
  background-color: rgb(37, 37, 37);
  z-index: 1;
  line-height: 30px;
  top: 10px;
}

.navLeft.collapsed .navLeft__item:hover .navLeft__itemName:after {
  content: " ";
  width: 10px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto auto auto -2px;
  border-top: 10px solid rgb(37, 37, 37);
  border-right: 10px solid rgb(37, 37, 37);
  transform: rotate(225deg);
}

.navLeft.collapsed .navLeft__settingTip {
  left: 65px;
}

/** 展开样式 **/
.navLeft .navLeft__service:hover i{
  color: #2587f6
}

.navLeft .navLeft__service:hover .navLeft__itemName{
    color: #2587f6
}

/*.navLeft__product {*/
  /*cursor: not-allowed;*/
/*}*/

.product__hover {
  background-color: #2587f6;
  color: #fff
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #1e222b;
}
.navAllPanelFade-enter,.navAllPanelFade-leave-to{
  opacity:  1;/*透明度*/
  transform: translateX(-1650px);
}
.navAllPanelFade-enter-active,.navAllPanelFade-leave-active{
  transition: all 0.5s;

}
.navLeft__list::-webkit-scrollbar {/*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
  border-radius: 5px;
}
.navLeft__list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}
.navLeft__list::-webkit-scrollbar-track {/*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 5px;
  background: #babdc4;
}
</style>